import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Languages } from '../../../constants';
import {
  CenteredTimeDisplayTypography,
  TimeSliderDialog,
} from './component-utils';
import { TimePointPicker } from './TimePointPicker';
import { TimePointSelectorHandle } from './types';
import { displayDate } from './utils-display';

export const TimeSliderPoint = ({
  timePointSelectorHandle,
  selectedLanguage,
}: {
  timePointSelectorHandle: TimePointSelectorHandle;
  selectedLanguage: Languages;
}) => {
  const [opened, setOpened] = useState(false);
  const [state] = timePointSelectorHandle;

  return (
    <Grid
      item
      container
      xs={12}
      justifyContent="center"
      alignItems="center"
      className="intercom_dashboard-time-slider"
    >
      {!opened && (
        <CenteredTimeDisplayTypography
          id="time-point-label"
          role="button"
          aria-haspopup="dialog"
          aria-expanded={opened}
          aria-controls="time-point-dialog"
          onMouseEnter={() => setOpened(true)}
          className="intercom_timeslider"
          color={'text.primary'}
        >
          {displayDate(
            state.date,
            state.selectedGranularity.value,
            selectedLanguage
          )}
        </CenteredTimeDisplayTypography>
      )}
      <TimeSliderDialog
        opened={opened}
        setOpened={setOpened}
        id="time-point-dialog"
        aria-labelledby="time-point-label"
      >
        <Grid item container justifyContent="center">
          <Grid item xs={12} style={{ maxHeight: 20 }}>
            <Typography variant="subtitle1">&nbsp;</Typography>
          </Grid>
          <TimePointPicker />
        </Grid>
      </TimeSliderDialog>
    </Grid>
  );
};
